import { render } from "./NovoMenu.vue?vue&type=template&id=6ea98e44&scoped=true"
import script from "./NovoMenu.vue?vue&type=script&lang=js"
export * from "./NovoMenu.vue?vue&type=script&lang=js"

import "./NovoMenu.vue?vue&type=style&index=0&id=6ea98e44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea98e44"]])

export default __exports__